export const toUnit = (unit: string) => (n: number) => `${n}${unit}`;
export const toPx = toUnit('px');
export const toRem = toUnit('rem');
